(function () {
  function run() {
    var params = new URLSearchParams(window.location.search);

    // items= is an ALLOW LIST (only show these handles)
    var itemsParam = params.get("items");

    // exclude= is a HIDE LIST (hide these handles)
    var excludeParam = params.get("exclude");

    // If neither param exists, do nothing (normal collection behavior)
    if (!itemsParam && !excludeParam) return;

    var allowed = null;
    if (itemsParam) {
      allowed = new Set(
        itemsParam
          .split(",")
          .map(function (s) { return s.trim().toLowerCase(); })
          .filter(Boolean)
      );
    }

    var excluded = new Set();
    if (excludeParam) {
      excluded = new Set(
        excludeParam
          .split(",")
          .map(function (s) { return s.trim().toLowerCase(); })
          .filter(Boolean)
      );
    }

    // Your theme uses li.grid__item for each product tile
    var tiles = document.querySelectorAll("li.grid__item");

    var shown = 0;

    tiles.forEach(function (tile) {
      var link = tile.querySelector('a[href*="/products/"], a[href^="/products/"]');
      if (!link) return;

      var href = link.getAttribute("href") || "";
      var match = href.match(/\/products\/([^\/\?\#]+)/);
      if (!match || !match[1]) return;

      var handle = match[1].toLowerCase();

      // 1) If items= is present, only show allowed handles
      if (allowed && !allowed.has(handle)) {
        tile.style.display = "none";
        return;
      }

      // 2) Always apply exclude= (hide blocked handles)
      if (excluded.has(handle)) {
        tile.style.display = "none";
        return;
      }

      // If it passes both checks, show it
      tile.style.display = "";
      shown++;
    });

    // Empty state (optional element)
    var empty = document.getElementById("availability-empty");
    if (empty) empty.style.display = shown === 0 ? "block" : "none";
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
})();
